import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Stack } from '@mui/material';
import { alpha } from '@mui/material/styles';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { BRAND } from '../theme';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        px: 3,
        py: 6,
      }}
    >
      <Typography
        aria-hidden
        sx={{
          fontFamily: '"Sora", sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(5rem, 20vw, 9rem)',
          lineHeight: 1,
          letterSpacing: '-0.04em',
          backgroundImage: `linear-gradient(135deg, ${BRAND.orangeBright} 0%, ${BRAND.orange} 60%, ${alpha(
            BRAND.orange,
            0.4
          )} 100%)`,
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
        }}
      >
        404
      </Typography>
      <Typography variant="h3" sx={{ mt: 1 }}>
        Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5, maxWidth: 440 }}>
        The page you're looking for doesn't exist or may have been moved. Let's get you back on
        track.
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ mt: 4, width: { xs: '100%', sm: 'auto' } }}>
        <Button
          variant="outlined"
          color="inherit"
          size="large"
          startIcon={<ArrowBackRoundedIcon />}
          onClick={() => navigate(-1)}
          sx={{ borderColor: 'divider' }}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          size="large"
          startIcon={<HomeRoundedIcon />}
          onClick={() => navigate('/')}
        >
          Go to Dashboard
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFound;
